import cn from 'classnames';
import { useCallback } from 'react';

import { SubtaskStatus } from '@webapp/account/src/resources/tasks/task';

import { Atom, Download as DownloadIco } from '@webapp/common/assets/icons';
import { Alert } from '@webapp/common/components/message';
import { nop } from '@webapp/common/lib/utils';

import css from './download.css';

export const Download: FC<{
    link: string;
    size?: number | boolean;
    onDownload?: () => void;
}> = ({ link, onDownload = nop }) => {
    const handleDownLoad = useCallback(() => {
        if (link) {
            window.open(link);
        } else {
            Alert.error('Битая ссылка');
        }
        onDownload && onDownload();
    }, [link, onDownload]);

    return (
        <div className={cn(css.action, css.download)} onClick={handleDownLoad}>
            <DownloadIco />
            {/*<span>Скачать {size && ` (${fileSize(size as number)})`}</span>*/}
            <span>Скачать</span>
        </div>
    );
};

export const Archive: FC<{
    onClick: () => void;
}> = ({ onClick }) => (
    <div className={css.action} onClick={onClick}>
        <Atom />
        <span>Сформировать архив</span>
    </div>
);

export const ReCreate: FC<{
    onClick: () => void;
}> = ({ onClick }) => (
    <div className={css.action}>
        <div className={cn(css.btn, css.create)} onClick={onClick}>
            Сформировать еще раз
        </div>
    </div>
);

export const getDownloadInfo = (
    status: SubtaskStatus,
    withFilters: boolean,
): {
    msg: string;
    iconClass: string;
} => {
    const info = withFilters
        ? {
              msg: 'архив формируется с учетом выбранных фильтров',
              iconClass: css.icon,
          }
        : {
              msg: null,
              iconClass: cn(css.icon, css.hide),
          };
    switch (status) {
        case SubtaskStatus.CREATED:
        case SubtaskStatus.WAITING:
        case SubtaskStatus.GET_FILES_INFO:
        case SubtaskStatus.SAVE_FILES_IN_ARCHIVE:
        case SubtaskStatus.SAVE_ARCHIVE_IN_S3:
            info.msg = 'когда архив будет готов, мы сообщим вам на e-mail';
            info.iconClass = cn(css.icon, css.warn);
            break;
        case SubtaskStatus.COMPLETE:
            info.msg = null;
            info.iconClass = cn(css.icon, css.hide);
            break;
        default:
    }

    return info;
};
